(() => {
  if (window.__pupLumeVariantGalleryScrollInstalled) return;
  window.__pupLumeVariantGalleryScrollInstalled = true;
  let scrollTimer;

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
    const optionName = target.getAttribute('name') || '';
    const fieldset = target.closest('fieldset');
    const legendText = fieldset?.querySelector('legend')?.textContent || '';
    const optionLabel = target.closest('[data-option-name]')?.getAttribute('data-option-name') || '';
    const context = [optionName, legendText, optionLabel].join(' ');
    if (!/\bcolou?r\b/i.test(context)) return;

    const productRoot = target.closest('product-information, .shopify-section') || document.querySelector('main');
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const selectors = ['media-gallery', 'product-media-gallery', '[data-testid*="media-gallery"]', '[id*="media-gallery"]', '[class*="product-media-gallery"]'];
      let gallery = null;
      for (const selector of selectors) {
        gallery = productRoot?.querySelector(selector) || null;
        if (gallery) break;
      }
      if (!gallery) {
        for (const selector of selectors) {
          gallery = document.querySelector('main ' + selector);
          if (gallery) break;
        }
      }
      if (!gallery) return;
      const offset = window.innerWidth <= 749 ? 12 : 24;
      const top = gallery.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 250);
  }, true);
})();